export const validation = {
  reasonRequired: 'The reason is required.',
};
